import { State } from "../../core/src/states/State";
import GameModel from "../../core/src/model/GameModel";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import BetModel from "../../core/src/model/BetModel";
import VendorModel from "../model/VendorModel";
import SpinModel from "../../core/src/model/SpinModel";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import PromotionalFreeGamesModel from "../model/PromotionalFreeGamesModel";
import Configs from "../vendorConfigs/Configs";
import ConsoleUtil from "../../core/src/utils/ConsoleUtil";
import Utils from "../../core/src/utils/Utils";
import App from "../../core/src/App";
import GameEvents from "../../core/src/const/GameEvents";


export default class AuthorizationState extends State {
    // TODO implement proper error handling
    // TODO implement demormlogin
    protected sessionData: any;
    public enter(): void {
        super.enter();

        if (GameModel.authToken) {
            ConsoleUtil.green("Login with auth token: " + GameModel.authToken);
            this.onUserReceived(null);
            return;
        }

        if (GameModel.urlParams.moneymode && GameModel.urlParams.moneymode == "real") {
            this.sendTokenRequest();
        } else {
            this.sendFunMoneyLogin();
        }
    }

    protected sendTokenRequest() {
        // CommManager.send(RequestRegister.get("tokenRequest"), (data) => {
        this.onUserReceived(null);
        // }, this);
    }

    protected sendFunMoneyLogin() {
        CommManager.send(RequestRegister.get("login"), (data) => {
            this.onUserReceived(data);
        }, this)
    }

    protected sendSessionRequest() {
        CommManager.send(RequestRegister.get("createSession"), (data) => {
            this.onSessionReceived(data);
        }, this)
    }
    protected sendGameDataRequest() {
        CommManager.send(RequestRegister.get("refreshRequest"), async (data) => {
            try {
                // Getting the reel sets from the backend
                if (data.data.gameData.reelLayouts) {
                    App.config.reelSets = data.data.gameData.reelLayouts;
                    App.dispatcher.emit(GameEvents.REEL_SETS_INITIALIZED);
                }

                // Make sure we have the real user balance.
                const realBalance = await this.sendGetBalanceRequest();

                // Moking the real data.
                const mockedData = Utils.deepClone(data);
                mockedData.data.gameData.balance = realBalance;

                this.onLoginReceived(mockedData);
            } catch (errorCode) {
                console.error(`ERROR: getBalance request returned error code: ${errorCode}. The balance MIGHT be wrong, until the user spins.`);
                this.onLoginReceived(data);
            }
        }, this)
    }

    /**
     * Gets the real user balance directly.
     * This is useful in cases, where the user has refunded/withdrawn their money,
     * by using a third party wallet/payment service in example.
     *
     * @protected
     * @return {*}  {Promise<number>}
     * @memberof AuthorizationState
     */
    protected async sendGetBalanceRequest(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            CommManager.send(
                RequestRegister.get("getBalance"),
                (data) => {
                    if (data.data.error == 0) {
                        resolve(parseFloat(data.data.chipBalance));
                    } else {
                        reject(data.data.error);
                    }
                },
                this
            );
        });
    }

    protected onUserReceived(data) {
        GameModel.update(data);
        this.sendSessionRequest();
    }

    protected onSessionReceived(data) {
        GameModel.restoreData = (data.data?.lastSessionData && data.data.lastSessionData.lastPlayState > 2) ? data.data.lastSessionData : null;
        GameModel.update(data);
        VendorModel.update(data);
        if (data.data.isHomeButtonAllowed !== undefined) {
            GameModel.isHomeButtonAllowed = data.data.isHomeButtonAllowed;
        }
        this.sessionData = data;
        this.sendGameDataRequest();
    }

    protected onLoginReceived(data) {
        Configs.game.parseClientConfig(data.data);
        GameModel.update(data);
        VendorModel.update(data);
        PromotionalFreeGamesModel.update(data);
        if (this.sessionData.data.lastSessionData?.betResult) {
            SpinModel.update(this.sessionData);
        } else {
            SpinModel.update(data);
        }
        BetModel.update(data);
        AutoplayModel.update(data);
        BetModel.setInitialParams();
        // TODO check data that comes when there are freespins active
        this.exit();
    }
}
